import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * PublicRoute - Guards public-only pages (like /login)
 * 
 * If user is authenticated → redirect to /dashboard
 * If user is not authenticated → render the page normally
 * 
 * This prevents authenticated users from seeing the login page
 * and blocks stale error banners from appearing.
 */
export default function PublicRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  // While checking auth state, don't render anything
  if (loading) {
    return null;
  }

  // If already authenticated, redirect to dashboard
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // Not authenticated, render the public page
  return children;
}
